module.exports = __webpack_public_path__ + "static/media/x43-logo.7c815a56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X43/x43-logo.svg
// module id = 380
// module chunks = 0